import type { IntroVideo } from './types';

/**
 * The intro/featured video on the introduction screen: a remote oEmbed (YouTube/
 * Vimeo) iframe or iFixit-hosted <video>, pinned to a responsive 16:9 box.
 */
export function IntroVideoPlayer({ video }: { video: IntroVideo }) {
   return (
      <div className="mb-[18px] aspect-video max-h-[65vh] w-full overflow-hidden rounded-2xl bg-black">
         {video.kind === 'embed' ? (
            <div
               className="size-full [&_iframe]:size-full [&_iframe]:border-0"
               // oEmbed iframe HTML from the guide API (server-provided embed markup).
               dangerouslySetInnerHTML={{ __html: video.html }}
            />
         ) : (
            <video
               className="size-full border-0"
               muted
               controls
               preload="auto"
               loop={Boolean(App.videoLooping)}
            >
               {video.sources.map((source, i) => (
                  <source key={i} src={source.src} type={source.type} />
               ))}
            </video>
         )}
      </div>
   );
}
